module.exports = __webpack_public_path__ + "static/media/eek17.704515d1.JPG";